import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Img = styled.image<{ isVisible: boolean }>`
  transition: opacity 0.3s;
  opacity: 0.001;

  ${props =>
    props.isVisible &&
    css`
      opacity: 1;
    `}
`

export const Svg = styled(motion.svg)`
  display: block;
  overflow: visible;
  margin: 0 auto;

  ${mq.ltLarge} {
    max-width: 80rem;
  }

  ${mq.large} {
    position: sticky;
    top: var(--header-height);
    max-height: calc(100vh - var(--header-height));
    max-height: calc(100dvh - var(--header-height));

    ${Img} {
      transition: none;
    }
  }
`

export const Scroll = styled.div`
  display: contents;

  ${mq.large} {
    display: block;
    height: 300vh;
    margin-top: -12rem;
  }
`

export const ClickablePoint = styled.path`
  ${mq.large} {
    display: none;
  }
`
